import {
  levels as baseLevels,
  getLevelStatus as baseGetLevelStatus,
  getShortLevelName as baseGetShortLevelName,
  Level as BaseLevel,
} from './baseLevels';

export type MissionGoalType = 'dailyAchievement' | 'teacherApproved';

export interface MissionGoal {
  id: string;
  type: MissionGoalType;
  text: string;
  shortText?: string;
}

export interface MusicWinterMission {
  id: string;
  text: string;
  type: string;
  gameId?: string;
  goals: MissionGoal[];
}

export interface MusicWinterLevel {
  id: string;
  title: string;
  missions: MusicWinterMission[];
  sideQuests?: MusicWinterMission[];
}

const clone = <T,>(value: T): T => JSON.parse(JSON.stringify(value)) as T;

const mapMissionToMusicWinter = (mission: any): MusicWinterMission => {
  const goals: MissionGoal[] = [];

  if (mission.id === 'beat-decoders-2') {
    goals.push(
      {
        id: 'beat-decoders-2-open-once',
        type: 'dailyAchievement',
        shortText: 'Open Beat Decoders',
        text: 'Complete the daily mission of opening Beat Decoders once.',
      },
      {
        id: 'beat-decoders-2-save-song',
        type: 'dailyAchievement',
        shortText: 'Save & Name a Song',
        text: 'Save at least one song that you create in Beat Decoders and give it a name.',
      },
      {
        id: 'beat-decoders-2-share-song',
        type: 'teacherApproved',
        shortText: 'Share a Song',
        text: 'Share your saved Beat Decoders song with other students (teacher approved).',
      },
    );
  }

  return {
    id: mission.id,
    text: mission.text,
    type: mission.type,
    gameId: (mission as any).gameId,
    goals,
  };
};

const seedLevels: BaseLevel[] = clone(baseLevels as unknown as BaseLevel[]);

export const levels: MusicWinterLevel[] = seedLevels.map(level => ({
  id: level.id,
  title: level.title,
  missions: (level.missions || []).map(mapMissionToMusicWinter),
  sideQuests: (level.sideQuests || []).map(mapMissionToMusicWinter),
}));

export const getLevelStatus = (levelId: string, currentLevelId: string, completedIds: string[]) => {
  return baseGetLevelStatus(levelId, currentLevelId, completedIds);
};

export const getShortLevelName = (title: string) => baseGetShortLevelName(title);
